<div class="text-center">
    <iframe width="600" height="600" src="https://datastudio.google.com/embed/reporting/d9384575-87d9-405c-a7d0-44f4e1323f8a/page/w6lXC" frameborder="0" style="border:0" allowfullscreen></iframe>
</div>